import * as React from 'react';
import useSafeTimeout from './use_safe_timeout';
export default function useDebounceCallback(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var fnRef = React.useRef(fn);
  var [setCallbackTimeout, clearCallbackTimeout] = useSafeTimeout();
  if (typeof fn !== 'function') {
    throw new TypeError('@veneer/core: Expected a function on the first argument');
  }
  fnRef.current = fn;
  return React.useMemo(() => {
    var func = function func() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      function debounceFn() {
        fnRef.current.apply(this, args);
      }
      clearCallbackTimeout();
      setCallbackTimeout(debounceFn, delay);
    };
    func.cancel = clearCallbackTimeout;
    return func;
  }, [clearCallbackTimeout, delay, setCallbackTimeout]);
}